/**
 * Date/localization helpers — month names and numeric locales follow the
 * active UI language (see src/i18n). UI code should use these instead of the
 * MONTHS_SHORT/MONTHS_LONG constants (which stay for the English ficha engine).
 */
import { format } from 'date-fns';
import i18n, { activeDateLocale } from '@/i18n';

/** BCP-47 locale for Intl.* APIs, matching the active UI language. */
export function uiLocale(): 'en-US' | 'es-ES' {
  return i18n.language === 'es' ? 'es-ES' : 'en-US';
}

/** "Jan" / "ene" for a 0-11 month index. */
export function monthShort(month: number): string {
  return format(new Date(2000, month, 1), 'LLL', { locale: activeDateLocale() });
}

/** "January" / "enero" for a 0-11 month index. */
export function monthLong(month: number): string {
  return format(new Date(2000, month, 1), 'LLLL', { locale: activeDateLocale() });
}
